import React, { Fragment, useState } from "react";
import { Collapse } from "reactstrap";

import { AssetTable } from "../AssetTable/AssetTable";
import arrow from "../../../../../public/svg/keyboard_arrow_down.svg";
import { toPascalCase } from "../../../../utils/helper";

import style from "./SubAssetClassTable.scss";

export const SubAssetClassTable = ({ subAssetClass, toggle, position, currency, portfolioTotal }) => {
  const [isCollapseBlueOpen, setIsCollapseBlueOpen] = useState(true);

  return (
    <Fragment>
      <tr
        className={style.collapseRow}
        onClick={() => {
          setIsCollapseBlueOpen(!isCollapseBlueOpen);
        }}
      >
        <td className={`${style.orangeRow} ${style.blueRow}`}>
          <span className={style.orangeRowText}>{toPascalCase(subAssetClass.name)}</span>
          <img
            className={!isCollapseBlueOpen ? style.arrow : style.arrowActivated}
            src={arrow}
            alt="arrow image"
          />
        </td>
      </tr>
      <Collapse className={style.collapse} isOpen={isCollapseBlueOpen}>
        <AssetTable
          subAssetClass={subAssetClass}
          toggle={toggle}
          position={position}
          currency={currency}
          portfolioTotal={portfolioTotal}
        />
      </Collapse>
    </Fragment>
  );
};
